export default {
  residentialAddress: null,
  acceptPrivacyAgreement: null
}
